import { CommonModule } from '@angular/common';
import { Component, HostListener, OnDestroy } from '@angular/core';
import { ProgressBarConfigItem, ProgressBarState } from './progress-bar.model';
import { Subscription } from 'rxjs';
import { ProgressBarService } from './progress-bar.service';
import { PROGRESS_BAR_MAP } from './progress-bar.const';

@Component({
  selector: 'app-progress-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
})
export class ProgressBarComponent implements OnDestroy {
  progressStatus!: ProgressBarState;
  progressBarSubscription!: Subscription;
  progressBarConfig = PROGRESS_BAR_MAP;
  progressBarConfigSubscription!: Subscription;

  get progressBarLinesConfig() {
    return this.progressBarConfig.slice(0, -1);
  }
  isScrolled = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.scrollY;
    this.isScrolled = scrollPosition > 85;
  }
  constructor(
    private progressBarService: ProgressBarService,
  ) {
    this.progressBarSubscription = this.progressBarService
      .getChangedProgressBarStatus()
      .subscribe((value: ProgressBarState) => {
        this.progressStatus = value;
      });

    this.progressBarConfigSubscription = this.progressBarService
      .getProgressBarConfig()
      .subscribe((value: ProgressBarConfigItem[]) => {
        this.progressBarConfig = value;
        if (!value.length) {
          this.progressBarService.changeProgressBarConfig(PROGRESS_BAR_MAP);
        }
      });
  }

  ngOnDestroy(): void {
    this.progressBarSubscription.unsubscribe();
    this.progressBarConfigSubscription.unsubscribe();
  }
}
